/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_First_Meeting_Title_LabelInputs */



/**
* | output |
* | --- |
* | "Title of the conversation" |
*
* @param {Onboarding_First_Meeting_Title_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_first_meeting_title_label = /** @type {((inputs?: Onboarding_First_Meeting_Title_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_First_Meeting_Title_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Titel van het gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Titre de la conversation")
	return /** @type {LocalizedString} */ ("Title of the conversation")
});